package org.example.project.client.model

data class ActivityFormValidationResult(
    val isValid: Boolean,
    val nameError: String? = null,
    val descriptionError: String? = null,
    val categoryError: String? = null,
    val minAgeError: String? = null,
    val maxAgeError: String? = null,
    val durationError: String? = null,
    val videoUrlError: String? = null
)

object ActivityFormValidator {

    fun validateVideoUrl(urlText: String?): String? {
        if (urlText.isNullOrBlank()) return null
        val trimmed = urlText.trim()
        if (trimmed.length > 2048) {
            return "Adres URL wideo nie może przekraczać 2048 znaków"
        }
        if (!trimmed.startsWith("https://", ignoreCase = true)) {
            return "Adres wideo musi zaczynać się od https://"
        }
        val withoutScheme = trimmed.substring(8)
        val host = withoutScheme
            .substringBefore('/')
            .substringBefore('?')
            .substringBefore('#')
            .substringBefore(':')
            .trim()
        if (host.isEmpty() || host.contains(" ")) {
            return "Adres wideo musi zawierać poprawny host"
        }
        return null
    }

    fun validate(
        name: String,
        description: String,
        category: String,
        minAgeText: String,
        maxAgeText: String,
        durationMinutesText: String,
        videoUrlText: String = ""
    ): ActivityFormValidationResult {
        var nameError: String? = null
        var descriptionError: String? = null
        var categoryError: String? = null
        var minAgeError: String? = null
        var maxAgeError: String? = null
        var durationError: String? = null
        val videoUrlError = validateVideoUrl(videoUrlText)

        val trimmedName = name.trim()
        if (trimmedName.isEmpty() || trimmedName.length > 200) {
            nameError = "Nazwa zabawy musi mieć od 1 do 200 znaków"
        }

        val trimmedDescription = description.trim()
        if (trimmedDescription.isEmpty() || trimmedDescription.length > 10000) {
            descriptionError = "Opis zabawy musi mieć od 1 do 10000 znaków"
        }

        val trimmedCategory = category.trim()
        if (trimmedCategory.isEmpty() || trimmedCategory.length > 100) {
            categoryError = "Rodzaj/kategoria musi mieć od 1 do 100 znaków"
        }

        val minAge = minAgeText.trim().toIntOrNull()
        if (minAge == null || minAge < 0 || minAge > 120) {
            minAgeError = "Wiek minimalny musi być liczbą od 0 do 120"
        }

        val maxAge = maxAgeText.trim().toIntOrNull()
        if (maxAge == null || maxAge < 0 || maxAge > 120) {
            maxAgeError = "Wiek maksymalny musi być liczbą od 0 do 120"
        } else if (minAge != null && minAge in 0..120 && maxAge < minAge) {
            maxAgeError = "Wiek maksymalny ($maxAge) nie może być mniejszy niż wiek minimalny ($minAge)"
        }

        val durationMinutes = durationMinutesText.trim().toIntOrNull()
        if (durationMinutes == null || durationMinutes < 1 || durationMinutes > 1440) {
            durationError = "Czas trwania musi wynosić od 1 do 1440 minut"
        }

        val isValid = nameError == null &&
            descriptionError == null &&
            categoryError == null &&
            minAgeError == null &&
            maxAgeError == null &&
            durationError == null &&
            videoUrlError == null

        return ActivityFormValidationResult(
            isValid = isValid,
            nameError = nameError,
            descriptionError = descriptionError,
            categoryError = categoryError,
            minAgeError = minAgeError,
            maxAgeError = maxAgeError,
            durationError = durationError,
            videoUrlError = videoUrlError
        )
    }

    fun validate(
        name: String,
        description: String,
        category: String,
        minAge: Int,
        maxAge: Int,
        durationMinutes: Int,
        videoUrl: String? = null
    ): ActivityFormValidationResult {
        return validate(
            name = name,
            description = description,
            category = category,
            minAgeText = minAge.toString(),
            maxAgeText = maxAge.toString(),
            durationMinutesText = durationMinutes.toString(),
            videoUrlText = videoUrl ?: ""
        )
    }
}
